import * as commissionModes from 'components/lease_structure/form/commission_modes';

export function canHaveLeaseTerms(fields) {
  return fields.leaseStructure && !fields.leaseStructure.hidden;
}

export function hasLeaseTerms(deal) {
  return deal.leaseTerms && !!deal.leaseTerms.filter(term => !term._destroy).length;
}

// Old components were built around the idea of an actual LeaseStructure model, which is getting
// kind of phased out for deals. Building one from a deal helps serve as a compatibility layer.
export function buildLeaseStructure(deal) {
  const leaseStructure = {
    commissionMode: deal.commissionMode,
    includeOperatingExpenses: deal.includeOperatingExpenses,
    leaseRateUnits: deal.leaseRateUnits,
    spaceSize: deal.spaceSize,
    spaceSizeUnits: deal.spaceSizeUnits,
    isRentCalculated: deal.isRentCalculated,
    leaseTerms: [],
  };

  if (deal.leaseTerms) {
    // The LeaseTerms table depends on index being set on each term
    leaseStructure.leaseTerms = deal.leaseTerms.map((term, index) => ({ ...term, index }));
  }

  return leaseStructure;
}

export function calculatesGrossCommissionAmount(deal) {
  return hasLeaseTerms(deal)
    && deal.commissionMode !== commissionModes.RATE_PER_SPACE_SIZE_UNIT
    && deal.commissionMode !== commissionModes.FLAT_RATE;
}

export function calculatesCommissionRate(deal) {
  return hasLeaseTerms(deal) && deal.commissionMode !== commissionModes.RATE_PER_SPACE_SIZE_UNIT;
}

export const calculatesGrossCommissionPercent = hasLeaseTerms;
export const calculatesLeaseRate = hasLeaseTerms;
export const calculatesLeaseTerm = hasLeaseTerms;
export const calculatesTransactionValue = hasLeaseTerms;
